const status = {
	running: "Aktiv",
	stopped: "Gestoppt",
	unknown: "Unbekannt",
};

export default status;
